import { WorkflowEditorService } from 'api-clients/monolith';
import { useApiService } from 'hooks';
import React from 'react';
import { useParams } from 'react-router-dom';

export function useRulesTargetStage({ externalId }: { externalId: string }) {
  const { funnelSlug } = useParams<{ funnelSlug?: string }>();
  const fetchRulesTargetStage = React.useCallback(
    () =>
      WorkflowEditorService.getInternalApiWorkflowEditorRulesEditData(
        externalId,
        funnelSlug,
        true,
        false,
      ),
    [externalId, funnelSlug],
  );

  return useApiService(fetchRulesTargetStage);
}
